import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Belgaumtotuljapurtourspackages() {



    const cardData = {




keyword: "Belgaum to Tuljapur Tour Package",

headingDescription: "Belgaum Taxi Service offers comfortable and customizable Belgaum to Tuljapur tour packages for devotees, families, senior citizens, couples, and groups planning a peaceful pilgrimage journey. Our Belgaum to Tuljapur tour package is designed to provide a convenient travel experience with private cab facilities, flexible schedules, and comfortable sightseeing options. Whether you are planning a one-day temple visit, a family religious trip, or a multi-destination Maharashtra pilgrimage tour, we provide reliable transportation with experienced drivers and well-maintained vehicles. Choose from Sedan, Swift Dzire, Ertiga, SUV, Innova, Innova Crysta, Tempo Traveller, and premium vehicles according to your group size and travel requirements. ",

topPlaces: [
  {
    title: "Tulja Bhavani Temple",
    description: "Tulja Bhavani Temple is one of Maharashtra's most important pilgrimage destinations dedicated to Goddess Bhavani. Devotees from Karnataka and Maharashtra visit this sacred temple throughout the year, especially during festivals and religious occasions."
  },
  {
    title: "Tuljapur",
    description: "Tuljapur is a famous religious town in Maharashtra known for its spiritual importance, temples, local markets, and peaceful surroundings. It is a preferred destination for families and devotees planning pilgrimage trips."
  },
  {
    title: "Solapur",
    description: "Solapur is a major city near Tuljapur known for textile industries, business activities, religious attractions, and commercial centers. It is a convenient stop for travelers exploring nearby Maharashtra destinations."
  },
  {
    title: "Akkalkot",
    description: "Akkalkot is a popular spiritual destination famous for Swami Samarth Maharaj Temple. Thousands of devotees visit this holy place every year, making it an important addition to Maharashtra pilgrimage tours."
  },
  {
    title: "Pandharpur",
    description: "Pandharpur is one of Maharashtra's most visited pilgrimage destinations, famous for Vitthal Rukmini Temple and Chandrabhaga River. Many travelers combine Tuljapur and Pandharpur in a single religious tour."
  },
  {
    title: "Bijapur",
    description: "Bijapur is a historic Karnataka city known for Gol Gumbaz, ancient monuments, and impressive architecture. It is a popular sightseeing destination for travelers from Belgaum visiting Maharashtra routes."
  },
  {
    title: "Kolhapur",
    description: "Kolhapur is a famous Maharashtra city known for Mahalaxmi Temple, historical attractions, traditional markets, and cultural heritage. It is a popular stop for religious and family tours."
  },
  {
    title: "Pune",
    description: "Pune is a major IT, education, and industrial hub in Maharashtra with corporate offices, technology parks, universities, and tourist attractions. Travelers often combine Pune with Maharashtra pilgrimage trips."
  },
  {
    title: "Mumbai",
    description: "Mumbai is India's financial capital known for business districts, airports, entertainment destinations, and famous tourist attractions. Private cab travel provides comfortable connectivity for extended Maharashtra tours."
  },
  {
    title: "Goa",
    description: "Goa is a popular coastal holiday destination known for beaches, resorts, churches, and sightseeing attractions. Travelers can combine religious tours with leisure trips using private cab services."
  }
],




"services": [
  {
    "name": "Belgaum to Tuljapur Tour Package",
    "description": "Plan a comfortable Belgaum to Tuljapur Tour Package with professional drivers, well-maintained AC vehicles, and flexible travel options. Visit the famous Tuljapur Bhavani Temple with family and friends using reliable cab services from Belgaum. Choose from Sedan, Ertiga, Innova Crysta, and premium vehicles for one day trips, pilgrimage tours, and customized travel packages with safe and convenient transportation."
  },
  {
    "name": "Belgaum to Tuljapur Cab",
    "description": "Book Belgaum to Tuljapur Cab for a smooth and hassle-free journey with experienced chauffeurs and comfortable vehicles. Get affordable one way and round trip cab options with doorstep pickup, transparent pricing, and 24x7 booking support. Our cabs are suitable for family travel, temple visits, business trips, and outstation journeys."
  },
  {
    "name": "Belgaum to Tuljapur Taxi",
    "description": "Choose Belgaum to Tuljapur Taxi service for safe and reliable outstation travel. Travel comfortably with clean AC cars, professional drivers, and multiple vehicle choices including Sedan, Ertiga, and Innova Crysta. Enjoy convenient taxi booking options for personal trips, pilgrimage tours, and weekend travel."
  },
  {
    "name": "Belgaum to Tuljapur Cab Service",
    "description": "Get dependable Belgaum to Tuljapur Cab Service with experienced chauffeurs, affordable fares, and premium travel facilities. Our cab services provide comfortable transportation for Tuljapur temple visits, family tours, corporate travel, and long-distance journeys with flexible pickup and drop locations."
  },
  {
    "name": "Belgaum to Tuljapur Taxi Service",
    "description": "Hire Belgaum to Tuljapur Taxi Service for a convenient and comfortable ride between Belgaum and Tuljapur. We offer reliable chauffeur-driven taxis with clean interiors, timely service, and budget-friendly packages for one way, round trip, and customized travel requirements."
  },
  {
    "name": "Belgaum to Tuljapur One Way Cab",
    "description": "Book Belgaum to Tuljapur One Way Cab for affordable single-side travel without return charges. Enjoy comfortable seating, professional drivers, fixed pricing, and doorstep pickup facilities. Perfect for passengers looking for economical and convenient outstation taxi services."
  },
  {
    "name": "Belgaum to Tuljapur One Way Taxi",
    "description": "Choose Belgaum to Tuljapur One Way Taxi for a cost-effective and comfortable journey. Our one way taxi services provide well-maintained vehicles, experienced chauffeurs, and flexible booking options for individuals, families, and pilgrimage travelers."
  },
  {
    "name": "Belgaum to Tuljapur Cab Booking",
    "description": "Complete Belgaum to Tuljapur Cab Booking easily with quick confirmation, multiple vehicle options, and reliable customer support. Select from Sedan, Ertiga, Innova Crysta, and SUV cabs for comfortable travel with professional drivers."
  },
  {
    "name": "Belgaum to Tuljapur Taxi Booking",
    "description": "Reserve Belgaum to Tuljapur Taxi Booking services for safe and convenient outstation transportation. Get affordable taxi fares, flexible travel plans, and comfortable AC vehicles for temple tours, family trips, and personal journeys."
  },
  {
    "name": "Belgaum to Tuljapur Car Rental",
    "description": "Hire Belgaum to Tuljapur Car Rental services for private and comfortable travel. Choose premium rental cars with drivers for sightseeing, pilgrimage visits, family tours, and customized outstation trips with complete travel convenience."
  },
  {
    "name": "Belgaum to Tuljapur Outstation Cab",
    "description": "Book Belgaum to Tuljapur Outstation Cab for reliable long-distance travel with professional chauffeurs and well-maintained vehicles. Our outstation cabs are available for one way, round trips, family tours, and customized travel packages."
  },
  {
    "name": "Belgaum to Tuljapur Innova Crysta Cab",
    "description": "Travel comfortably with Belgaum to Tuljapur Innova Crysta Cab offering spacious seating, premium interiors, and excellent comfort for long journeys. Ideal for families, groups, pilgrimage tours, and corporate travel requirements."
  },
  {
    "name": "Belgaum to Tuljapur Ertiga Cab",
    "description": "Book Belgaum to Tuljapur Ertiga Cab for affordable and spacious travel with comfortable seating capacity. Perfect for family trips, small groups, temple visits, and outstation journeys with professional driver assistance."
  },
  {
    "name": "Belgaum to Tuljapur Sedan Cab",
    "description": "Choose Belgaum to Tuljapur Sedan Cab for economical and comfortable travel. Enjoy clean AC sedan cars, experienced chauffeurs, smooth rides, and affordable fares for personal and business journeys."
  },
  {
    "name": "Belgaum to Tuljapur Round Trip Cab",
    "description": "Book Belgaum to Tuljapur Round Trip Cab for flexible return travel packages. Enjoy convenient pickup, waiting time options, comfortable vehicles, and reliable drivers for temple visits, family tours, and weekend trips."
  },
  {
    "name": "Belgaum to Tuljapur Private Taxi",
    "description": "Hire Belgaum to Tuljapur Private Taxi for a personalized travel experience with dedicated vehicles and professional chauffeurs. Enjoy privacy, comfort, flexible timings, and safe transportation throughout your journey."
  },
  {
    "name": "Cheap Belgaum to Tuljapur Cab",
    "description": "Find Cheap Belgaum to Tuljapur Cab services with affordable pricing and quality travel facilities. Get budget-friendly outstation taxis without compromising on safety, comfort, vehicle quality, and professional service."
  },
  {
    "name": "Best Belgaum to Tuljapur Tour Package",
    "description": "Choose the Best Belgaum to Tuljapur Tour Package for a memorable pilgrimage and family travel experience. Get customized cab packages with comfortable vehicles, experienced drivers, and flexible sightseeing options."
  },
  {
    "name": "Online Belgaum to Tuljapur Cab Booking",
    "description": "Book Online Belgaum to Tuljapur Cab Booking services with easy reservations, instant confirmation, and multiple vehicle choices. Enjoy convenient travel planning with reliable cab availability and customer assistance."
  },
  {
    "name": "Belgaum to Tuljapur Family Tour",
    "description": "Plan a comfortable Belgaum to Tuljapur Family Tour with spacious cabs, professional drivers, and customized travel schedules. Perfect for family temple visits, holidays, and weekend getaways."
  }
],
"tableData": [
  ["Belgaum to Tuljapur Tour Package", "Belgaum to Tuljapur Cab"],
  ["Belgaum to Tuljapur Taxi", "Belgaum to Tuljapur Cab Service"],
  ["Belgaum to Tuljapur Taxi Service", "Belgaum to Tuljapur One Way Cab"],
  ["Belgaum to Tuljapur Cab Booking", "Belgaum to Tuljapur Taxi Booking"],
  ["Belgaum to Tuljapur Car Rental", "Belgaum to Tuljapur Outstation Cab"],
  ["Belgaum to Tuljapur Innova Crysta Cab", "Belgaum to Tuljapur Ertiga Cab"],
  ["Belgaum to Tuljapur Sedan Cab", "Belgaum to Tuljapur Round Trip Cab"],
  ["Belgaum to Tuljapur Private Taxi", "Cheap Belgaum to Tuljapur Cab"],
  ["Best Belgaum to Tuljapur Tour Package", "Online Belgaum to Tuljapur Cab Booking"],
  ["Belgaum to Tuljapur Family Tour", "Belgaum to Tuljapur Travel Package"]
],





whychoose: [
  {
    WhyChooseheading: "Comfortable Belgaum to Tuljapur Tour Package",
    WhyChoosedescription: "Plan a memorable pilgrimage trip from Belgaum to Tuljapur with a private cab package offering comfortable travel, flexible schedules, and convenient sightseeing arrangements."
  },
  {
    WhyChooseheading: "Perfect Package for Devotees & Families",
    WhyChoosedescription: "Our Belgaum to Tuljapur tour packages are designed for families, senior citizens, and devotees looking for a peaceful and comfortable journey to the famous temple destination."
  },
  {
    WhyChooseheading: "Private Cab with Complete Travel Freedom",
    WhyChoosedescription: "Travel in your own dedicated vehicle without sharing rides, allowing you to manage your timings, stops, and trip plans according to your convenience."
  },
  {
    WhyChooseheading: "Vehicle Options for Every Group Size",
    WhyChoosedescription: "Choose from Sedan, Swift Dzire, Ertiga, Innova, Innova Crysta, and SUV vehicles based on your group size, luggage, and comfort preferences."
  },
  {
    WhyChooseheading: "Flexible One Day & Multi Day Plans",
    WhyChoosedescription: "Customize your Tuljapur trip with suitable travel duration, return options, and additional stops based on your pilgrimage or sightseeing requirements."
  },
  {
    WhyChooseheading: "Experienced Drivers for Temple Routes",
    WhyChoosedescription: "Professional chauffeurs help ensure a smooth journey with proper route knowledge, safe driving, and comfortable travel throughout the trip."
  },
  {
    WhyChooseheading: "Convenient Pickup from Belgaum",
    WhyChoosedescription: "Start your journey from your preferred location in Belgaum including home, hotel, office, railway station, or airport area."
  },
  {
    WhyChooseheading: "Hassle-Free Tour Planning",
    WhyChoosedescription: "Get assistance with vehicle selection, travel planning, and booking support to make your Belgaum to Tuljapur tour comfortable and stress-free."
  }
]

};

const faqData = [
  {
    question: "What is included in a Belgaum to Tuljapur Tour Package?",
    answer: "The package generally includes private cab transportation from Belgaum to Tuljapur with flexible travel options. Additional services depend on the selected package."
  },
  {
    question: "Can I book a one-day Tuljapur tour from Belgaum?",
    answer: "Yes, one-day return tour packages can be planned according to your travel schedule and requirements."
  },
  {
    question: "Which vehicles are available for the Tuljapur tour?",
    answer: "Sedan, Swift Dzire, Ertiga, Innova, Innova Crysta, and SUV cabs are available based on passenger count and comfort needs."
  },
  {
    question: "Is this tour package suitable for senior citizens?",
    answer: "Yes, comfortable private vehicles with experienced drivers are suitable for senior citizens and family pilgrimage trips."
  },
  {
    question: "Can I customize the Belgaum to Tuljapur itinerary?",
    answer: "Yes, the travel plan can be customized according to your preferred timings, stops, and sightseeing requirements."
  },
  {
    question: "Can I book a round-trip cab from Belgaum to Tuljapur?",
    answer: "Yes, round-trip taxi packages are available with flexible return schedules."
  },
  {
    question: "Do you provide pickup from Belgaum Airport or Railway Station?",
    answer: "Yes, pickup and drop services can be arranged from Belgaum Airport, Railway Station, hotels, and other preferred locations."
  },
  {
    question: "Are temple visits and sightseeing included in the package?",
    answer: "Sightseeing arrangements can be added according to the selected tour package and travel requirements."
  },
  {
    question: "Are toll and parking charges included in the package?",
    answer: "Additional charges such as toll, parking, and other applicable expenses depend on the selected package and are explained during booking."
  },
  {
    question: "How can I book a Belgaum to Tuljapur Tour Package?",
    answer: "Share your travel date, number of passengers, preferred vehicle, and trip requirements to get suitable package details and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Ganesh Patil",
    feedback: "Our Belgaum to Tuljapur pilgrimage trip was very comfortable. The driver was helpful, and the vehicle provided enough space for our family.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Kavita Deshmukh",
    feedback: "The tour package made our temple visit easy and convenient. The cab was clean, the journey was smooth, and the service was excellent.",
    rating: 5
  }
];





    const Images = [
        { place: "/images/keyword/1.jpg", text: "Cab Service in Belgaum", link: "Cab-Service-in-Belgaum" },
        { place: "/images/keyword/2.jpg", text: "Belgaum Taxi Service", link: "Belgaum-Taxi-Service" },
        { place: "/images/keyword/3.jpg", text: "Belgaum to Goa Cab", link: "Belgaum-to-Goa-Cab" },
        { place: "/images/keyword/4.jpg", text: "Belgaum to Mahabaleshwar Cab", link: "Belgaum-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/5.jpg", text: "Belgaum to Kerala Cab Service", link: "Belgaum-to-Kerala-Cab-Service" },
        { place: "/images/keyword/6.jpg", text: "Goa to Belgaum Cab", link: "Goa-to-Belgaum-Cab" },
        { place: "/images/keyword/7.jpg", text: "Belgaum to Mumbai Cab", link: "Belgaum-to-Mumbai-Cab" },
        { place: "/images/keyword/8.jpg", text: "Belgaum to Bangalore Cab", link: "Belgaum-to-Bangalore-Cab" },
        { place: "/images/keyword/9.jpg", text: "Goa Cab Service", link: "Goa-Cab-Service" },
        { place: "/images/keyword/10.jpg", text: "Taxi Service in Goa", link: "Taxi-Service-in-Goa" },
        { place: "/images/keyword/11.jpg", text: "Cheapest Cab Service in Goa", link: "Cheapest-Cab-Service-in-Goa" },
        { place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Belgaum", link: "Corporate-Cab-Services-in-Belgaum" },
        { place: "/images/keyword/13.jpg", text: "Innova Crysta Rent in Belgaum", link: "Innova-Crysta-Rent-in-Belgaum" },
        { place: "/images/keyword/14.jpg", text: "Ertiga on Rent in Belgaum", link: "Ertiga-on-Rent-in-Belgaum" },
        { place: "/images/keyword/15.jpg", text: "Tempo Traveller Rent in Belgaum", link: "Tempo-Traveller-Rent-in-Belgaum" },
        { place: "/images/keyword/16.jpg", text: "Mini Bus Rental Belgaum", link: "Mini-Bus-Rental-Belgaum" },
        { place: "/images/keyword/17.jpg", text: "Swift Dzire on Rent in Belgaum", link: "Swift-Dzire-on-Rent-in-Belgaum" },
        { place: "/images/keyword/18.jpg", text: "Urbania on Rent in Belgaum", link: "Urbania-on-Rent-in-Belgaum" },
        { place: "/images/keyword/19.jpg", text: "Wedding Car Rental in Belgaum", link: "Wedding-Car-Rental-in-Belgaum" },
        { place: "/images/keyword/20.jpg", text: "Cabs in Belgaum", link: "Cabs-in-Belgaum" },
        { place: "/images/keyword/21.jpg", text: "Belgaum to Hubli Cab", link: "Belgaum-to-Hubli-Cab" },
        { place: "/images/keyword/22.jpg", text: "Belgaum to Dharwad Cab", link: "Belgaum-to-Dharwad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Belgaum to Kolhapur Cab", link: "Belgaum-to-Kolhapur-Cab" },
        { place: "/images/keyword/24.jpg", text: "Belgaum Airport Cab Service", link: "Belgaum-Airport-Cab-Service" },
        { place: "/images/keyword/25.jpg", text: "Belgaum to Bagalkot Cab", link: "Belgaum-to-Bagalkot-Cab" },
    ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Belgaum to Tuljapur Tour Package",
  "image": "https://www.belgaumtaxiservice.com/assets/images/belgaum-to-tuljapur-tour-package.webp",
  "description":
    "Book Belgaum to Tuljapur Tour Package with Belgaum Taxi Service for safe, comfortable, and affordable pilgrimage taxi services. We provide one-way and round-trip cabs from Belgaum to Tuljapur with Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7 for temple visits, family tours, religious trips, and long-distance travel.",
  "brand": {
    "@type": "Brand",
    "name": "Belgaum Taxi Service"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.belgaumtaxiservice.com/belgaum-to-tuljapur-tour-package"
  }
};






    return (
        <div>


<Helmet>
  <title>Belgaum to Tuljapur Tour Package | Taxi Package | +91 8722158435</title>

  <meta
    name="description"
    content="Book Belgaum to Tuljapur Tour Package with Belgaum Taxi Service for reliable one-way and round-trip pilgrimage taxi services. Travel from Belgaum to Tuljapur in Sedan, Ertiga, SUV, Innova, or Innova Crysta with comfortable and affordable temple tour packages available 24x7."
  />

  <meta
    name="keywords"
    content="Belgaum to Tuljapur Tour Package, Belgaum to Tuljapur Cab, Belgaum to Tuljapur Taxi, Belgaum to Tuljapur Cab Service, Belgaum to Tuljapur Taxi Service, Belgaum to Tuljapur One Way Cab, Belgaum to Tuljapur One Way Taxi, Belgaum to Tuljapur Cab Booking, Belgaum to Tuljapur Taxi Booking, Belgaum to Tuljapur Tour Package"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>






            <div className="page-headder bg-section parallaxie">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="page-header-box text-white">
                                <h1 className="text-anime-style-3 text-center text-white">
                                    {cardData.keyword}
                                </h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>













            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/50.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Belgaum Taxi Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Belgaum Taxi Service</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Belgaum Taxi Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918722158435 " className="pc-call">+91 8722158435 </a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/918722158435 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918722158435 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@belgaumtaxiservice.com" className="pc-email">
                                            booking@belgaumtaxiservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Belgaum Taxi Service</strong><br />
                                            P No 30 cCTS No 7023,
                                            Sector No 9 Malmaruti Anjaneya Nagar,
                                            Belgaum, Karnataka - 590017




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Belgaumtotuljapurtourspackages ;